$('.posts.show, .private_posts.show').ready(function(){

  // Scrolling
  // When the user scrolls the page, execute scrollprogressFunction
  //window.onscroll = function() {updatescrollProgress()};

  function updatescrollProgress() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    document.getElementById("ProgressBar").style.width = scrolled + "%";
  }

});
